import { Component, DestroyRef, inject, signal, ViewChild } from '@angular/core';
import { catchError, EMPTY, finalize } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from 'core/services/auth.service';
import { LeftSidebarComponent } from './blocks/left-sidebar/left-sidebar.component';
import { CategoriesService } from 'core/services/categories.service';
import { RouterModule, RouterOutlet } from '@angular/router';
import { KorviuLoaderComponent } from '../shared/components/korviu-loader/korviu-loader.component';
import { HeaderComponent } from './blocks/header/header.component';
import { BreadcrumbComponent } from './blocks/breadcrumb/breadcrumb.component';
import { FooterComponent } from '../shared/components/footer/footer.component';
import { BalanceService } from 'core/services/balance.service';

@Component({
  selector: 'app-workspace',
  templateUrl: './workspace.component.html',
  styleUrl: './workspace.component.scss',
  standalone: true,
  imports: [
    KorviuLoaderComponent,
    LeftSidebarComponent,
    HeaderComponent,
    BreadcrumbComponent,
    RouterModule,
    FooterComponent,
    RouterOutlet
  ]
})
export class WorkspaceComponent {
  @ViewChild('leftSideBar') leftSideBarComponent: LeftSidebarComponent;

  readonly #destroyRef = inject(DestroyRef);
  readonly #authService = inject(AuthService);
  readonly #balanceService = inject(BalanceService);
  readonly #categoriesService = inject(CategoriesService);

  public readonly workspaceIsLoading = signal(false);
  public leftSidebardCollapsed = true;

  public ngOnInit(): void {
    this.#balanceService.resetTransactionSummary();
    this._loadWorkspaceData();
    this._warmTransactionSummary();
    this._warmFavoritesList();
  }

  public onUncollapseClick(): void {
    this.leftSideBarComponent.uncollapse();
  }

  private _loadWorkspaceData(): void {
    this.workspaceIsLoading.set(true);
    this.#authService
      .getMe()
      .pipe(
        finalize(() => {
          this.workspaceIsLoading.set(false);
        }),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe();
  }

  private _warmFavoritesList(): void {
    this.#categoriesService.getFavoritesIdsList().pipe(takeUntilDestroyed(this.#destroyRef)).subscribe();
  }

  private _warmTransactionSummary(): void {
    this.#balanceService
      .loadTransactionSummary()
      .pipe(
        catchError(() => EMPTY),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe();
  }
}
